var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar"},[_c('div',{staticClass:"bg"},[_c('img',{attrs:{"src":_vm.bg}})]),_vm._v(" "),_c('ul',_vm._l((_vm.navBox),function(item){return _c('li',[_c('img',{attrs:{"src":'static/nav/'+item.img}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.title))])])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70cea4d2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Index/navBar.vue
// module id = null
// module chunks = 